import { Col, Row } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import BotonSubmit from "../../../components/Boton/BotonSubmit";
import { MapaGoogle } from "../../../components/mapaGoogle/MapaGoogle";
import CardPage from "../../../layout/CardPage";
import { Cita } from "./cita/Cita";
import { Conexion } from "./conexion/Conexion";
import { startPostDestino } from "../../../context/actions/detalleActions";
import { DatosDrawer } from "../datosDrawer/DatosDrawer";

//
export const MapaDestino = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { asistenciaID } = useParams();
  const { asistencia } = useSelector((state) => state.detalleReducer);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [latLng, setLatLng] = useState({
    lat: 19.364612026633605,
    lng: -99.18838994738087,
  });

  const [body, setBody] = useState({ esCita: false });

  const campaniaID = asistencia?.asegurado?.campania?.campaniaID;

  const getDatos = (datos) => {
    const salida = {
      asistenciaID,
      direccion: datos.direccionCompleta,
      municipio: datos.municipio,
      estado: datos.estado,
      cp: datos.cp,
      lat: datos.lat.toString(),
      lng: datos.lng.toString(),
    };
    setBody({
      ...body,
      ...salida,
    });
  };

  const handleClick = async () => {
    setLoading(true);
    try {
      await dispatch(startPostDestino(body));

      history.push(`/detalleAsistencia/${asistenciaID}`);
    } finally {
      setLoading(false);
    }
  };

  const AgregaDatos = (ele) =>
    setBody({
      ...body,
      ...ele,
    });

  //
  return (
    <>
      <CardPage
        titulo="Establecer Dirección Destino"
        tituloBoton="Regresar"
        accionBoton={() => history.push(`/detalleAsistencia/${asistenciaID}`)}
        tituloBoton2={campaniaID == 59 ? "Corralones" : undefined}
        accionBoton2={campaniaID == 59 ? () => setDrawerVisible(true) : undefined}
      >
        <MapaGoogle getDatos={getDatos} latLng={latLng} setLatLng={setLatLng} />

        <Row gutter={10}>
          <Col span={3}>
            <Conexion AgregaDatos={AgregaDatos} />
          </Col>
          <Col span={6}>
            <Cita AgregaDatos={AgregaDatos} esCita={body.esCita} />
          </Col>
          <Col span={4}>
            <BotonSubmit
              disabled={!body}
              onClick={handleClick}
              tituloBoton="Guardar Destino"
              loading={loading}
            />
          </Col>
        </Row>
      </CardPage>
      <DatosDrawer
        visible={drawerVisible}
        onClose={() => setDrawerVisible(false)}
      />
    </>
  );
};
